import { render, staticRenderFns } from "./SubstationManagement.vue?vue&type=template&id=cba97ba6&scoped=true&"
import script from "./SubstationManagement.vue?vue&type=script&lang=js&"
export * from "./SubstationManagement.vue?vue&type=script&lang=js&"
import style0 from "./SubstationManagement.vue?vue&type=style&index=0&id=cba97ba6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba97ba6",
  null
  
)

export default component.exports